export default {
  install(Vue, options) {
    Vue.prototype.$perm = function (permission, campusId) {
      const user = this.$store.state.auth.user;
      if (!user) {
        return false;
      }
      if (campusId === 0) {
        return true;
      }
      const campusPermissions = user.campusPermissions;
      let permissions = campusPermissions.find(
        campus => campus.campus_id == campusId
      );

      if (_.isUndefined(campusId)) {
        permissions = {
          campus_id: undefined,
          permissions: []
        };

        for (let i = 0; i < campusPermissions.length; i++) {
          permissions.permissions = permissions.permissions.concat(
            campusPermissions[i].permissions
          );
        }
      }

      if (!permissions) {
        return false;
      }

      if (_.isArray(permission)) {
        let hasAccess = false;

        for (let i = 0; i < permission.length; i++) {
          if (permissions.permissions.includes(permission[i])) {
            hasAccess = true;
          }
        }

        return hasAccess;
      } else if (_.isString(permission)) {
        return permissions.permissions.includes(permission);
      } else {
        return false;
      }
    };
  }
};
